import {deliveryApi} from "@/axios";

export function getBsInfoByContract(data){
    return deliveryApi({
        url: '/contract/system/contract/properties',
        method: 'post',
        data:data,
    })
}
